import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useDarkMode } from '../../contexts/DarkModeContext';
import { toast } from 'react-toastify';
import { checkCode, clearCheckError, clearCheckSuccess } from '../../redux/slices/checkCodeSlice';
import './CheckCode.css';

function CheckCode() {
  const { isDarkMode } = useDarkMode();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [code, setCode] = useState('');
  
  const { isChecking, checkError, checkSuccess, checkResult } = useSelector((state) => state.checkCode);

  // Handle effects for success and error
  useEffect(() => {
    if (checkError) {
      toast.error(checkError.message || 'حدث خطأ في تفعيل الكود');
      dispatch(clearCheckError());
      // إعادة تحميل الصفحة في حالة الفشل
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    }
  }, [checkError, dispatch]);

  useEffect(() => {
    if (checkSuccess) {
      toast.success(checkResult?.message || 'تم تفعيل الكود بنجاح');
      dispatch(clearCheckSuccess());
      // إعادة توجيه إلى صفحة البروفايل
      setTimeout(() => {
        navigate('/profile');
      }, 2000);
    }
  }, [checkSuccess, checkResult, dispatch, navigate]);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!code.trim()) {
      toast.error('يرجى إدخال كود المادة');
      return;
    }

    dispatch(checkCode({ code: code.trim() }));
  };

  return (
    <div className={`check-code-page ${isDarkMode ? 'dark-mode' : 'light-mode'}`} style={{padding : "140px 0"}}>
      <div className="container">
        <div className="check-code-container">
          <div className="check-code-header">
            <h1 className="check-code-title">تفعيل كود المادة</h1>
            <p className="check-code-subtitle">
              أدخل كود المادة  لتفعيل المحتوى
            </p>
          </div>

          <div className="check-code-form-container">
            <form onSubmit={handleSubmit} className="check-code-form">
              <div className="form-group">
                <label htmlFor="code" className="form-label">
                  كود المادة
                </label>
                <input
                  type="text"
                  id="code"
                  className="form-control"
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                  placeholder="أدخل كود المادة هنا..."
                  maxLength="10"
                  required
                />
                <small className="form-text">
                  مثال: 248520
                </small>
              </div>

              <button
                type="submit"
                className="btn btn-primary submit-btn"
                disabled={isChecking}
              >
                {isChecking ? 'جاري التفعيل...' : 'تفعيل الكود'}
              </button>
            </form>
          </div>

          <div className="check-code-info">
            <h3>كيفية الحصول على الكود؟</h3>
            <div className="code-sources">
              <div className="source-item">
                <h4>من خلال إدارة المنصة</h4>
                <p>يمكنك التواصل مع إدارة المنصة للحصول على كود المادة الخاص بك</p>
              </div>
              
              <div className="source-item">
                <h4>من خلال المعلم</h4>
                <p>يمكنك طلب كود المادة من معلم المادة في المدرسة</p>
              </div>
              
              <div className="source-item">
                <h4>من خلال إدارة السنتر</h4>
                <p>يمكنك الحصول على الكود من إدارة مركز التعليم</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CheckCode; 